<template>
  <component :is="embedded ? 'div' : 'global-layout'">
    <div class="erp-page">
      <a-card size="small">
        <div class="todo-header">
          <span class="todo-title">系统待办管理</span>
          <a-space>
            <a-button :loading="loading" icon="reload" @click="load">刷新</a-button>
            <a-button v-if="admin" :loading="scanning" @click="scan">检查待办</a-button>
            <a-button v-if="activeTab === 'rules' && admin" type="primary" @click="editRule()">新增提醒规则</a-button>
          </a-space>
        </div>
        <a-alert v-if="error" type="error" show-icon :message="error"/>
        <a-alert v-if="!enabled && admin" type="warning" show-icon message="待办功能尚未启用；请先部署数据表，再启用服务端开关。"/>
        <a-tabs v-model="activeTab" @change="resetPage">
          <a-tab-pane key="todos" tab="待办事项"/>
          <a-tab-pane key="rules" tab="提醒规则"/>
        </a-tabs>
        <div class="todo-filters">
          <a-select v-model="filter.reminderType" allowClear placeholder="提醒类型" style="width: 210px" @change="resetPage">
            <a-select-option value="RECEIPT_OVERDUE_DIRECT">直营收货超时</a-select-option>
            <a-select-option value="RECEIPT_OVERDUE_FRANCHISE">加盟收货超时</a-select-option>
            <a-select-option value="BI_INVENTORY_CHANGE_MISMATCH">BI 库存变动异常</a-select-option>
          </a-select>
          <select-organization v-model="filter.organizationId" placeholder="关联组织" style="width: 200px" @change="resetPage"/>
          <a-input v-if="activeTab === 'todos'" v-model="filter.sourceId" allowClear placeholder="完整来源编号"
                   style="width: 190px" @pressEnter="resetPage"/>
          <a-select v-if="activeTab === 'todos'" v-model="filter.status" allowClear placeholder="待办状态"
                    style="width: 130px" @change="resetPage">
            <a-select-option value="TODO">未完成</a-select-option>
            <a-select-option value="DONE">已完成/恢复</a-select-option>
            <a-select-option value="CLOSED">已关闭</a-select-option>
          </a-select>
          <a-button @click="resetPage">查询</a-button>
        </div>
      </a-card>
      <a-card class="erp-section" size="small">
        <a-table rowKey="id" size="small" :columns="columns" :dataSource="rows" :loading="loading"
                 :pagination="pagination" :scroll="{x: 1150}" :locale="{emptyText: '暂无数据'}" @change="changePage">
          <template slot="reminderType" slot-scope="value">{{ reminderTypeText(value) }}</template>
          <template slot="state" slot-scope="value, record">
            <a-tag :color="statusColor(record)">{{ statusText(record) }}</a-tag>
          </template>
          <template slot="flag" slot-scope="value">{{ value ? '是' : '否' }}</template>
          <template slot="action" slot-scope="value, record">
            <a-space v-if="activeTab === 'todos'">
              <a v-if="record.sourceType === 'SALE_INPUT' && record.status === 'TODO'" @click="showDelay(record)">延期</a>
              <a v-if="record.sourceType === 'SALE_INPUT'" @click="showLogs(record)">延期记录</a>
            </a-space>
            <a v-else @click="editRule(record)">设置</a>
          </template>
        </a-table>
      </a-card>
      <a-modal title="延后提醒" :visible="delayVisible" :maskClosable="false" :confirmLoading="saving"
               @ok="saveDelay" @cancel="!saving && (delayVisible = false)">
        <p>单据：{{ delay.sourceId }}</p>
        <p v-if="delay.oldUntil">原延期截止时间：{{ delay.oldUntil }}</p>
        <a-form-model layout="vertical">
          <a-form-model-item label="延后提醒至（北京时间）" required>
            <a-date-picker v-model="delay.delayUntil" show-time format="YYYY-MM-DD HH:mm:ss"
                           valueFormat="YYYY-MM-DD HH:mm:ss" style="width: 100%"/>
          </a-form-model-item>
          <a-form-model-item label="延期原因" required>
            <a-textarea v-model="delay.reason" :maxLength="500" :rows="3" placeholder="例如：物流延迟，预计明日到货"/>
          </a-form-model-item>
        </a-form-model>
        <a-alert type="info" show-icon message="延期对该单据的全部匹配人员生效。单据未完成时，截止后将再次提醒。"/>
      </a-modal>
      <a-modal title="提醒规则" :visible="ruleVisible" :maskClosable="false" :confirmLoading="saving"
               @ok="saveRule" @cancel="!saving && (ruleVisible = false)">
        <a-form-model layout="vertical">
          <a-form-model-item label="提醒类型" required>
            <a-select v-model="rule.reminderType">
              <a-select-option value="RECEIPT_OVERDUE_DIRECT">直营收货超时</a-select-option>
              <a-select-option value="RECEIPT_OVERDUE_FRANCHISE">加盟收货超时</a-select-option>
              <a-select-option value="BI_INVENTORY_CHANGE_MISMATCH">BI 库存变动异常</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="接收组织（精确匹配）" required>
            <select-organization v-model="rule.organizationId"/>
          </a-form-model-item>
          <a-form-model-item label="提醒职务" required>
            <go-dict-select v-model="rule.postionId" dictCode="sys_postion,id,postion_name"/>
          </a-form-model-item>
          <a-form-model-item v-if="rule.reminderType !== 'BI_INVENTORY_CHANGE_MISMATCH'" label="制单后超过多少小时提醒" required>
            <a-input-number v-model="rule.timeoutHours" :min="1" :max="8760" :precision="0"/>
          </a-form-model-item>
          <a-form-model-item>
            <a-checkbox v-if="rule.reminderType !== 'BI_INVENTORY_CHANGE_MISMATCH'" v-model="rule.forceFlag">强制处理</a-checkbox>
            <a-checkbox v-model="rule.enabled">启用</a-checkbox>
          </a-form-model-item>
        </a-form-model>
        <a-alert type="info" show-icon message="数据监控提醒为普通提醒，不阻断业务；组织和职务决定接收人。"/>
      </a-modal>
      <a-modal title="延期记录" :visible="logsVisible" :width="'85%'" :footer="null" @cancel="logsVisible = false">
        <a-alert v-if="logsError" type="error" :message="logsError"/>
        <a-table rowKey="id" size="small" :columns="logColumns" :dataSource="logs" :loading="logsLoading"
                 :pagination="logPagination" :scroll="{x: 900}" @change="changeLogPage"/>
      </a-modal>
    </div>
  </component>
</template>

<script>
import {getAction, postAction} from '@/api/manage'
import GlobalLayout from '@/components/page/GlobalLayout'
import SelectOrganization from '@/components/select/SelectOrganization'
import GoDictSelect from '@/components/tools/GoDictSelect'

const typeColumn = {title: '提醒类型', dataIndex: 'reminderType', width: 170, scopedSlots: {customRender: 'reminderType'}}
export default {
  name: 'SystemTodoList',
  components: {GlobalLayout, SelectOrganization, GoDictSelect},
  props: {embedded: {type: Boolean, default: false}},
  data() {
    return {
      admin: false,
      enabled: false,
      activeTab: 'todos',
      filter: {},
      rows: [],
      pageNo: 1,
      total: 0,
      loading: false,
      saving: false,
      scanning: false,
      error: '',
      disposed: false,
      reloadNeeded: false,
      delayVisible: false,
      delay: {},
      ruleVisible: false,
      rule: {},
      logsVisible: false,
      logsLoading: false,
      logsAgain: false,
      logsError: '',
      logs: [],
      logId: '',
      logPage: 1,
      logTotal: 0,
      logColumns: [
        {title: '操作时间', dataIndex: 'createTime', width: 170},
        {title: '管理员', dataIndex: 'operatorName', width: 120},
        {title: '原截止时间', dataIndex: 'oldDelayUntil', width: 170},
        {title: '延期至', dataIndex: 'delayUntil', width: 170},
        {title: '原因', dataIndex: 'reason'}
      ]
    }
  },
  computed: {
    pagination() {
      return {current: this.pageNo, pageSize: 20, total: this.total, showTotal: n => '共 ' + n + ' 条'}
    },
    logPagination() {
      return {current: this.logPage, pageSize: 20, total: this.logTotal}
    },
    columns() {
      if (this.activeTab === 'rules') {
        return [
          typeColumn, {title: '接收组织', dataIndex: 'organizationName'},
          {title: '提醒职务', dataIndex: 'postionName'},
          {title: '超时（小时）', dataIndex: 'timeoutHours'},
          {title: '强制处理', dataIndex: 'forceFlag', scopedSlots: {customRender: 'flag'}},
          {title: '启用', dataIndex: 'enabled', scopedSlots: {customRender: 'flag'}},
          {title: '操作', key: 'action', scopedSlots: {customRender: 'action'}}
        ]
      }
      return [
        typeColumn, {title: '标题', dataIndex: 'title', width: 260, ellipsis: true},
        {title: '来源编号', dataIndex: 'sourceId', width: 180},
        {title: '关联组织', dataIndex: 'organizationName', width: 140},
        {title: '产生时间', dataIndex: 'billCreateTime', width: 165},
        {title: '提醒起点', dataIndex: 'dueTime', width: 165},
        {title: '状态', dataIndex: 'status', width: 100, scopedSlots: {customRender: 'state'}},
        {title: '内容', dataIndex: 'content', width: 300, ellipsis: true},
        {title: '延期至', dataIndex: 'delayUntil', width: 165},
        {title: '最近延期原因', dataIndex: 'delayReason', width: 180, ellipsis: true},
        {title: '操作', key: 'action', width: 145, scopedSlots: {customRender: 'action'}}
      ]
    }
  },
  async created() {
    try {
      const res = await getAction('/system/todo/mine', {pageSize: 1})
      if (this.disposed) return
      if (!res.success) throw new Error(res.message)
      this.admin = !!res.result.admin
      this.enabled = !!res.result.enabled
      if (!this.admin) throw new Error('仅管理员可管理系统待办')
      await this.load()
    } catch (e) {
      if (!this.disposed) this.error = e.message || '读取待办管理权限失败'
    }
  },
  beforeDestroy() {
    this.disposed = true
  },
  methods: {
    reminderTypeText(value) {
      if (value === 'RECEIPT_OVERDUE_DIRECT') return '直营收货超时'
      if (value === 'RECEIPT_OVERDUE_FRANCHISE') return '加盟收货超时'
      if (value === 'BI_INVENTORY_CHANGE_MISMATCH') return 'BI 库存变动异常'
      return value || '其他提醒'
    },
    async scan() {
      if (this.scanning) return
      this.scanning = true
      try {
        const res = await postAction('/system/todo/scan', {})
        if (this.disposed) return
        if (!res.success) throw new Error(res.message)
        this.$message.success(res.message)
        this.$emit('changed')
        await this.load()
      } catch (e) {
        if (!this.disposed) this.$message.error(e.message || '待办检查失败')
      } finally {
        if (!this.disposed) this.scanning = false
      }
    },
    statusText(row) {
      if (row.status === 'DONE') return row.sourceType === 'DATA_MONITOR' ? '已恢复' : '已审核'
      if (row.status === 'CLOSED') return '已关闭'
      if (!row.dueTime) return '规则未启用'
      return row.delayed ? '延期中' : '未完成'
    },
    statusColor(row) {
      return row.status === 'DONE' ? 'green' : row.status === 'CLOSED' ? 'default' : row.delayed ? 'orange' : 'red'
    },
    async load() {
      if (!this.admin || this.disposed) return
      if (this.loading) {
        this.reloadNeeded = true;
        return
      }
      this.loading = true
      const tab = this.activeTab
      const params = {pageNo: this.pageNo, pageSize: 20}
      Object.keys(this.filter).forEach(key => {
        if (this.filter[key]) params[key] = this.filter[key]
      })
      try {
        const url = '/system/todo/' + (tab === 'rules' ? 'rules' : 'list')
        const res = await getAction(url, params)
        if (this.disposed || tab !== this.activeTab) return
        if (!res.success) throw new Error(res.message)
        this.rows = res.result.records || []
        this.total = res.result.total || 0
        this.error = ''
      } catch (e) {
        if (!this.disposed) this.error = e.message || '读取失败，请重试'
      } finally {
        if (!this.disposed) {
          this.loading = false
          if (this.reloadNeeded) {
            this.reloadNeeded = false;
            this.load()
          }
        }
      }
    },
    resetPage() {
      this.pageNo = 1;
      this.rows = [];
      this.load()
    },
    changePage(page) {
      this.pageNo = page.current;
      this.load()
    },
    showDelay(row) {
      this.delay = {id: row.id, sourceId: row.sourceId, version: row.version, oldUntil: row.delayUntil, delayUntil: null, reason: ''}
      this.delayVisible = true
    },
    async saveDelay() {
      if (!this.delay.delayUntil || !this.delay.reason.trim()) {
        this.$message.warning('请填写延期时间和原因');
        return
      }
      await this.save('/system/todo/delay', {id: this.delay.id, version: this.delay.version, delayUntil: this.delay.delayUntil, reason: this.delay.reason}, 'delayVisible')
    },
    editRule(row) {
      this.rule = row ? {...row, forceFlag: !!row.forceFlag, enabled: !!row.enabled} : {
        reminderType: this.filter.reminderType || 'RECEIPT_OVERDUE_DIRECT',
        organizationId: this.filter.organizationId,
        postionId: null,
        timeoutHours: 24,
        forceFlag: true,
        enabled: true
      }
      this.ruleVisible = true
    },
    async saveRule() {
      const monitorReminder = this.rule.reminderType === 'BI_INVENTORY_CHANGE_MISMATCH'
      if (!this.rule.organizationId || !this.rule.postionId || (!monitorReminder && (!Number.isInteger(this.rule.timeoutHours) || this.rule.timeoutHours < 1))) {
        this.$message.warning('请填写组织、职务和正整数超时小时数');
        return
      }
      const {id, reminderType, organizationId, postionId, forceFlag, enabled} = this.rule
      const timeoutHours = monitorReminder ? 0 : this.rule.timeoutHours
      await this.save('/system/todo/saveRule', {id, reminderType, organizationId, postionId, timeoutHours, forceFlag: monitorReminder ? false : forceFlag, enabled}, 'ruleVisible')
    },
    async save(url, data, modal) {
      if (this.saving) return
      this.saving = true
      try {
        const res = await postAction(url, data)
        if (this.disposed) return
        if (!res.success) throw new Error(res.message)
        this[modal] = false
        this.$message.success(res.message)
        this.$emit('changed')
        await this.load()
      } catch (e) {
        if (!this.disposed) this.$message.error(e.message || '保存失败')
      } finally {
        if (!this.disposed) this.saving = false
      }
    },
    showLogs(row) {
      this.logId = row.id;
      this.logPage = 1;
      this.logs = [];
      this.logsVisible = true;
      this.loadLogs()
    },
    changeLogPage(page) {
      this.logPage = page.current;
      this.loadLogs()
    },
    async loadLogs() {
      if (this.logsLoading) {
        this.logsAgain = true;
        return
      }
      this.logsLoading = true
      const id = this.logId
      const page = this.logPage
      try {
        const res = await getAction('/system/todo/delayLogs', {id, pageNo: page, pageSize: 20})
        if (this.disposed) return
        if (id !== this.logId || page !== this.logPage) {
          this.logsAgain = true;
          return
        }
        if (!res.success) throw new Error(res.message)
        this.logs = res.result.records || []
        this.logTotal = res.result.total || 0
        this.logsError = ''
      } catch (e) {
        if (!this.disposed) this.logsError = e.message || '读取延期记录失败'
      } finally {
        if (!this.disposed) {
          this.logsLoading = false
          if (this.logsAgain) {
            this.logsAgain = false;
            this.loadLogs()
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.erp-page {
  padding: 8px;
  background: #f5f5f5;
}

.erp-section {
  margin-top: 8px;
}

.todo-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  min-height: 48px;
}

.todo-title {
  font-size: 18px;
}

.todo-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

@media (max-width: 700px) {
  .todo-header {
    flex-wrap: wrap;
  }
}
</style>
